import { Tab, Nav, Card, Button, Alert, Row, Col, Form, Spinner, Badge, Container } from 'react-bootstrap';
import React, { useState, useEffect } from "react";
import Layout from "../../../../layout/default";
import Block from "../../../../components/Block/Block";
import { Image, Media } from "../../../../components";
import axios from 'axios';
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';
import api from "../../../../services/auth/api";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { FaUser, FaPhone, FaIdCard, FaEdit, FaDollarSign, FaToggleOn, FaUsers, FaPiggyBank } from "react-icons/fa";
import { BsCardHeading } from "react-icons/bs";
import { FaMapMarkerAlt, FaPhoneAlt, FaCity, FaMapPin, FaGlobeAsia, FaMapSigns, FaLocationArrow, FaCodeBranch, FaUserTie } from 'react-icons/fa';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FiPhone } from 'react-icons/fi';
import { FaRupeeSign } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { useSearchParams } from "react-router-dom";
import moment from 'moment';

const UserProfilePage = () => {
    const [username, setUsername] = useState('');
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [addressDetails, setAddressDetails] = useState(null);
    const [listData, setListData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [countPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState("all");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dateFilterApplied, setDateFilterApplied] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPreviousPage, setHasPreviousPage] = useState(false);
    const [treeData, setTreeData] = useState({
        left_leg: 0,
        mid_leg: 0,
        right_leg: 0,
        professional: []
    });
    const [treeLoading, setTreeLoading] = useState(true);
    const [treeError, setTreeError] = useState("");
    const [searchParams] = useSearchParams();
    const tabFromQuery = searchParams.get("tab");
    const [activeTab, setActiveTab] = useState(tabFromQuery || "tabOne");
    const [bankDetails, setBankDetails] = useState(null);
    const [bankLoading, setBankLoading] = useState(false);
    const [profPage, setProfPage] = useState(1);
    const [profRowsPerPage, setProfRowsPerPage] = useState(10);
    const user_name = localStorage.getItem("user_name");
    const user_id = localStorage.getItem("user_id");

    useEffect(() => {
        const storedUsername = localStorage.getItem('user_name');
        if (storedUsername) {
            setUsername(storedUsername);
        }
    }, []);

    useEffect(() => {
        if (tabFromQuery) {
            setActiveTab(tabFromQuery);
            navigate("/shop/auths/user-profile-page", { replace: true });
        }
    }, [tabFromQuery, navigate]);

    const maskSensitiveData = (data) => {
        if (typeof data === 'string' && data.length >= 4) {
            return data.slice(0, 4) + " **** " + data.slice(-4);
        }
        return data || "";
    };

    const fetchUserDetails = async () => {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");

        if (authToken) {
            try {
                Swal.fire({
                    title: 'Loading...',
                    text: 'Fetching your details. Please wait.',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                const response = await axios.get(`${process.env.REACT_APP_HOST}api/getUserdetails`, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                if (response.data.data) {
                    setUserDetails(response.data.data);
                } else {
                    setUserDetails(null);
                }
                setLoading(false);
                Swal.close();
            } catch (err) {
                setLoading(false);
                console.error("Error fetching User Details:", err);
                setError('Failed to fetch user details. Please try again later.');
                Swal.close();
            }
        } else {
            setLoading(false);
            setError('No auth token found. Please log in.');
        }
    };

    const fetchAddressDetails = async () => {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");

        if (authToken) {
            try {
                Swal.fire({
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                const response = await axios.get(`${process.env.REACT_APP_HOST}api/addres/getUserAddress`, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                if (response.data.data) {
                    setAddressDetails(response.data.data);
                } else {
                    setAddressDetails(null);
                }
                setLoading(false);
                Swal.close();
            } catch (err) {
                setLoading(false);
                console.error("Error fetching address:", err);
                setError('Failed to fetch address details. Please try again later.');
                Swal.close();
            }
        } else {
            setLoading(false);
            setError('No auth token found. Please log in.');
        }
    };

    const fetchUnpinnedChildren = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            const response = await axios.get(
                `${process.env.REACT_APP_HOST}api/user/get-unpinned-childrens`,
                {
                    params: { user_id: user_id },
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (response.data.success) {
                // Calculate total professional count
                const totalProfessional = response.data.professional?.reduce((sum, prof) => sum + prof.count, 0) || 0;

                setTreeData({
                    left_leg: response.data.left_leg || 0,
                    mid_leg: response.data.mid_leg || 0,
                    right_leg: response.data.right_leg || 0,
                    professional: response.data.professional || [],
                    total_professional: totalProfessional // Add this new field
                });
            } else {
                setTreeError(response.data.message || "Failed to fetch data.");
            }
        } catch (err) {
            setTreeError(err.response?.data?.message || "Network error. Please try again.");
        } finally {
            setTreeLoading(false);
        }
    };
    const fetchBankDetails = async () => {
        setBankLoading(true);
        setError(''); // Clear previous errors
        const authToken = localStorage.getItem("authToken");

        if (authToken) {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOST}api/get-user-bank`, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                // Handle API response structure
                if (response.data.status === true && response.data.data) {
                    setBankDetails(response.data.data); // Bank details exist
                } else {
                    debugger;
                    setBankDetails(null); // No bank details found
                }
            } catch (err) {
                console.error("Error fetching Bank Details:", err);
                if (err.response && err.response.status === 404) {
                    setBankDetails(null); // Treat 404 as "no bank details"
                } else {
                    setError('Failed to fetch bank details. Please try again later.');
                }
            } finally {
                setBankLoading(false);
            }
        } else {
            setBankLoading(false);
            setError('No auth token found. Please log in.');
        }
    };

    const handleAddBankDetails = () => {
        navigate('/shop/auths/user-bank-detail');
    };

    const handleEditBankDetails = () => {
        if (bankDetails && bankDetails.id) {
            navigate(`/shop/auths/edit-user-bank-detail/${bankDetails.id}`);
        }
    };

    const handleEdit = () => {
        if (userDetails && userDetails.id) {
            navigate(`/shop/auths/update-user-details/${userDetails.id}`);
        } else {
            setError('No user found to edit.');
        }
    };

    const handleEditAddress = () => {
        if (addressDetails && addressDetails.length > 0) {
            navigate(`/shop/auths/edit-address/${addressDetails[0].id}`);
        } else {
            setError('No address found to edit.');
        }
    };

    const getPayoutList = async () => {
        setLoading(true);

        const authToken = localStorage.getItem('authToken');
        const user_id = localStorage.getItem('user_id');

        const params = {
            page: currentPage,
            per_page: countPerPage,
        };

        if (statusFilter !== "all") {
            params['filter[]'] = statusFilter === "paid" ? "1" : "0";
        }
        if (startDate && endDate) {
            params['start_date'] = startDate.toISOString().split('T')[0];
            params['end_date'] = endDate.toISOString().split('T')[0];
        }

        try {
            const response = await api.get(`${process.env.REACT_APP_HOST}api/userpayout`, {
                params,
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            const data = response.data.data;
            const total = response.data.data.length;

            setListData(data);
            setTotalRows(total);

            setHasNextPage(countPerPage * currentPage < total);
            setHasPreviousPage(currentPage > 1);
        } catch (error) {
            setListData([]);
            setTotalRows(0);
            setHasNextPage(false);
            setHasPreviousPage(false);
            console.error("Error fetching payout list:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (selectedOption) => {
        setStatusFilter(selectedOption.value);
        setCurrentPage(1);
        setDateFilterApplied(false);
    };

    const handleGoClick = () => {
        if (startDate && endDate) {
            setDateFilterApplied(true);
            getPayoutList();
        } else {
            Swal.fire('Error', 'Please select both start and end date.', 'error');
        }
    };

    const payoutListDataColumns = [
        {
            name: (<span><FaUser className="me-1" />User ID</span>),
            selector: (row) => row.user_id,
            cell: (row) => <span className="d-block text-nowrap">{row.user_id}</span>,
            sortable: true,
            minWidth: "100px"
        },
        {
            name: (<span><FaRupeeSign className="me-1" />Amount</span>),
            selector: (row) => row.amount,
            cell: (row) => <span className="d-block text-nowrap">{row.amount}</span>,
            sortable: true,
            minWidth: "100px"
        },
        {
            name: (<span><FaToggleOn className="me-1" />Status</span>),
            selector: (row) => (row.is_paid ? "Paid" : "Unpaid"),
            cell: (row) => (
                <span className={`badge ${row.is_paid ? "bg-success" : "bg-warning text-dark"}`}>
                    {row.is_paid ? "Paid" : "Unpaid"}
                </span>
            ),
            sortable: true,
            minWidth: "100px"
        },
        {
            name: (<span><FaUsers className="me-1" />Pinning Group</span>),
            selector: (row) => row.pinning_group_names,
            cell: (row) => (
                <div className="table-wrapper">
                    <table className="table table-sm table-bordered mb-0 text-nowrap">
                        <thead className="table-light">
                            <tr>
                                <th>Full Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {row.pinning_group_names.map((item, index) => (
                                <tr key={index}>
                                    <td>{`${item.first_name} ${item.last_name}`}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ),
            sortable: false,
            grow: 2,
            wrap: true,
            minWidth: "200px"
        },
        {
            name: (<span><i className="me-1 bi bi-calendar3" />Created At</span>),
            selector: (row) => row.created_at,
            cell: (row) => (
                <span className="d-block text-nowrap">
                    {moment(row.created_at).format("DD MMM YYYY, hh:mm A")}
                </span>
            ),
            sortable: true,
            minWidth: "180px"
        }
    ];

    useEffect(() => {
        if (activeTab === 'tabOne') {
            fetchUserDetails();
            fetchAddressDetails();
        } else if (activeTab === 'tabTwo' && !dateFilterApplied) {
            getPayoutList();
        } else if (activeTab === 'tabThree') {
            fetchUnpinnedChildren();
        } else if (activeTab === 'tabFour') {
            fetchBankDetails();
        }
    }, [activeTab, dateFilterApplied]);

    return (
        <Layout title="My Profile" content="container">
            <Block.Head>
                <Block.HeadBetween className="align-items-start">
                    <Block.HeadContent>
                        <div className="d-flex flex-column flex-md-row align-items-center">
                            <Media size="xl" shape="circle" className="me-0 me-md-3 mb-3 mb-md-0">
                                <Image
                                    src="/shop/images/avatar/profile-img.png"
                                    alt="Profile"
                                    className="img-thumbnail"
                                    style={{ width: '80px', height: '80px' }}
                                />
                            </Media>
                            <div className="text-center text-md-start">
                                <h3 className="title mb-1">{username || 'User Profile'}</h3>
                                <p className="text-muted mb-0">Member since {new Date().toLocaleDateString()}</p>
                            </div>
                        </div>
                    </Block.HeadContent>
                </Block.HeadBetween>
            </Block.Head>

            <Tab.Container activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
                <div className="d-flex justify-content-center justify-content-md-start">
                    <Block>
                        <Nav variant="pills" className="nav-pills-border nav-pills-custom flex-nowrap overflow-auto">
                            <Nav.Item className="flex-shrink-0 me-2">
                                <Nav.Link
                                    eventKey="tabOne"
                                    className="py-2 px-3 fw-medium"
                                    active={activeTab === 'tabOne'}>
                                    <FaUser className="me-1 d-none d-md-inline" />
                                    Profile
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-shrink-0  me-2">
                                <Nav.Link
                                    eventKey="tabTwo"
                                    className="py-2 px-3 fw-medium"
                                    active={activeTab === 'tabTwo'}
                                >
                                    <FaRupeeSign className="me-1 d-none d-md-inline" />
                                    Payouts
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-shrink-0  me-2">
                                <Nav.Link
                                    eventKey="tabThree"
                                    className="py-2 px-3 fw-medium"
                                    active={activeTab === 'tabThree'}
                                >
                                    <FaUsers className="me-1 d-none d-md-inline" />
                                    Team
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-shrink-0  me-2">
                                <Nav.Link
                                    eventKey="tabFour"
                                    className="py-2 px-3 fw-medium"
                                    active={activeTab === 'tabFour'}
                                >
                                    <FaPiggyBank className="me-1 d-none d-md-inline" />
                                    Bank Details
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Block>
                </div>

                <Tab.Content className="mt-3">
                    <Tab.Pane eventKey="tabOne">
                        <Card className="mb-4">
                            <Card.Body>
                                <Row className="g-4">
                                    <Col md={6}>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h4 className="mb-0">Personal Information</h4>
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={handleEdit}
                                            >
                                                <FaEdit className="me-1" />
                                                Edit
                                            </Button>
                                        </div>

                                        <div className="list-group list-group-flush">
                                            <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                <div>
                                                    <small className="text-muted d-block">First Name</small>
                                                    <span>{userDetails?.first_name || 'N/A'}</span>
                                                </div>
                                                <FaUser className="text-muted" />
                                            </div>
                                            <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                <div>
                                                    <small className="text-muted d-block">Last Name</small>
                                                    <span>{userDetails?.last_name || 'N/A'}</span>
                                                </div>
                                                <FaUser className="text-muted" />
                                            </div>
                                            <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                <div>
                                                    <small className="text-muted d-block">Phone</small>
                                                    <span>{userDetails?.phone_1 || 'N/A'}</span>
                                                </div>
                                                <FiPhone className="text-muted" />
                                            </div>
                                            <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                <div>
                                                    <small className="text-muted d-block">Email</small>
                                                    <span>{userDetails?.email || 'N/A'}</span>
                                                </div>
                                                <FiMail className="text-muted" />
                                            </div>
                                        </div>
                                    </Col>

                                    <Col md={6}>
                                        {loading && (
                                            <div className="text-center py-5">
                                                <Spinner animation="border" variant="primary" />
                                            </div>
                                        )}

                                        {error && (
                                            <Alert variant="danger" className="mb-4">
                                                {error}
                                            </Alert>
                                        )}

                                        {addressDetails && addressDetails.length > 0 ? (
                                            <>
                                                {addressDetails.filter(address => address.address_type === 1).length > 0 && (
                                                    <div>
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <h4 className="mb-0">Permanent Address</h4>
                                                            <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                onClick={handleEditAddress}
                                                            >
                                                                <FaEdit className="me-1" />
                                                                Edit
                                                            </Button>
                                                        </div>

                                                        <Card className="border">
                                                            <Card.Body>
                                                                {addressDetails.filter(address => address.address_type === 0).map((address, index) => (
                                                                    <div key={index}>
                                                                        <div className="d-flex align-items-start mb-3">
                                                                            <FaMapMarkerAlt className="mt-1 me-2 text-primary" />
                                                                            <div>
                                                                                <h6 className="mb-1">Address</h6>
                                                                                <p className="mb-0">{address.address}</p>
                                                                            </div>
                                                                        </div>

                                                                        <Row className="g-2">
                                                                            <Col xs={6}>
                                                                                <div className="d-flex align-items-start">
                                                                                    <FaPhoneAlt className="mt-1 me-2 text-primary" />
                                                                                    <div>
                                                                                        <h6 className="mb-1">Phone</h6>
                                                                                        <p className="mb-0">{address.phone_number}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xs={6}>
                                                                                <div className="d-flex align-items-start">
                                                                                    <FaMapPin className="mt-1 me-2 text-primary" />
                                                                                    <div>
                                                                                        <h6 className="mb-1">Pin Code</h6>
                                                                                        <p className="mb-0">{address.pin_code}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xs={6}>
                                                                                <div className="d-flex align-items-start">
                                                                                    <FaGlobeAsia className="mt-1 me-2 text-primary" />
                                                                                    <div>
                                                                                        <h6 className="mb-1">State</h6>
                                                                                        <p className="mb-0">{address.state_name}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xs={6}>
                                                                                <div className="d-flex align-items-start">
                                                                                    <FaMapSigns className="mt-1 me-2 text-primary" />
                                                                                    <div>
                                                                                        <h6 className="mb-1">District</h6>
                                                                                        <p className="mb-0">{address.district_name}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                            <Col xs={6}>
                                                                                <div className="d-flex align-items-start">
                                                                                    <FaCity className="mt-1 me-2 text-primary" />
                                                                                    <div>
                                                                                        <h6 className="mb-1">City</h6>
                                                                                        <p className="mb-0">{address.city_name}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                            {address.zone_name && (
                                                                                <Col xs={6}>
                                                                                    <div className="d-flex align-items-start">
                                                                                        <FaLocationArrow className="mt-1 me-2 text-primary" />
                                                                                        <div>
                                                                                            <h6 className="mb-1">Zone</h6>
                                                                                            <p className="mb-0">{address.zone_name}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                            )}
                                                                        </Row>
                                                                    </div>
                                                                ))}
                                                            </Card.Body>
                                                        </Card>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <Card className="border">
                                                <Card.Body className="text-center py-4">
                                                    <FaMapMarkerAlt className="text-muted mb-2" size={24} />
                                                    <h5>No Address Found</h5>
                                                    <p className="text-muted">Please add your address details</p>
                                                    <Button variant="primary" size="sm">
                                                        Add Address
                                                    </Button>
                                                </Card.Body>
                                            </Card>
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <br />
                        <br />
                    </Tab.Pane>

                    <Tab.Pane eventKey="tabTwo">
                        <Card className="mb-4">
                            <Card.Body>
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
                                    <div className="mb-3 mb-md-0">
                                        <h4 className="mb-0">Payout History</h4>
                                        <p className="text-muted mb-0">View your earnings and transactions</p>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Select
                                            options={[
                                                { value: "all", label: "All" },
                                                { value: "paid", label: "Paid" },
                                                { value: "unpaid", label: "Unpaid" },
                                            ]}
                                            value={{
                                                value: statusFilter,
                                                label: statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1),
                                            }}
                                            onChange={handleFilterChange}
                                            className="me-2"
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    minWidth: "120px"
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="row g-3 mb-4">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Start Date"
                                                value={startDate}
                                                onChange={(newValue) => setStartDate(newValue)}
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        size: "small",
                                                        variant: "outlined"
                                                    },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="End Date"
                                                value={endDate}
                                                onChange={(newValue) => setEndDate(newValue)}
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        size: "small",
                                                        variant: "outlined"
                                                    },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div className="col-12 col-lg-4 d-flex align-items-end">
                                        <Button
                                            onClick={handleGoClick}
                                            className="w-100"
                                            disabled={!startDate || !endDate}
                                        >
                                            Apply Filter
                                        </Button>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <DataTable
                                        columns={payoutListDataColumns}
                                        data={listData}
                                        highlightOnHover
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        paginationPerPage={countPerPage}
                                        paginationComponentOptions={{
                                            noRowsPerPage: true,
                                            next: {
                                                disabled: !hasNextPage,
                                            },
                                            previous: {
                                                disabled: !hasPreviousPage,
                                            },
                                        }}
                                        onChangePage={(page) => setCurrentPage(page)}
                                        progressPending={loading}
                                        noDataComponent={
                                            <div className="py-4 text-center">
                                                <FaRupeeSign size={32} className="text-muted mb-2" />
                                                <h5>No Payouts Found</h5>
                                                <p className="text-muted">You don't have any payouts yet</p>
                                            </div>
                                        }
                                        responsive
                                        dense
                                    />
                                </div>
                            </Card.Body>
                        </Card>
                        <br />
                        <br />
                    </Tab.Pane>

                    <Tab.Pane eventKey="tabThree">
                        <Card className="mb-4">
                            <Card.Body>
                                {treeLoading ? (
                                    <div className="text-center py-5">
                                        <Spinner animation="border" variant="primary" />
                                        <p className="mt-2">Loading your network...</p>
                                    </div>
                                ) : treeError ? (
                                    <Alert variant="danger" className="text-center">
                                        {treeError}
                                    </Alert>
                                ) : (
                                    <>
                                        <div className="text-center mb-4 d-none d-md-block">
                                            <h4 className="mb-1">{user_name}</h4>
                                        </div>

                                        <Row className="g-3 d-none d-md-flex">
                                            <Col md={3}> {/* Changed from md={4} to md={3} to make space for 4 columns */}
                                                <Card className="h-100 border-primary">
                                                    <Card.Body className="text-center">
                                                        <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px' }}>
                                                            <FaCodeBranch className="text-primary" size={24} />
                                                        </div>
                                                        <h5 className="mb-1">Blue Team</h5>
                                                        <Badge pill bg="primary" className="fs-5 px-3 py-2 mb-2">
                                                            {treeData.left_leg}
                                                        </Badge>
                                                        <p className="text-muted mb-0">Members</p>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col md={3}> {/* Changed from md={4} to md={3} */}
                                                <Card className="h-100 border-warning">
                                                    <Card.Body className="text-center">
                                                        <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px' }}>
                                                            <FaCodeBranch className="text-warning" size={24} />
                                                        </div>
                                                        <h5 className="mb-1">Yellow Team</h5>
                                                        <Badge pill bg="warning" className="fs-5 px-3 py-2 mb-2 text-dark">
                                                            {treeData.mid_leg}
                                                        </Badge>
                                                        <p className="text-muted mb-0">Members</p>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col md={3}> {/* Changed from md={4} to md={3} */}
                                                <Card className="h-100 border-success">
                                                    <Card.Body className="text-center">
                                                        <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px' }}>
                                                            <FaCodeBranch className="text-success" size={24} />
                                                        </div>
                                                        <h5 className="mb-1">Green Team</h5>
                                                        <Badge pill bg="success" className="fs-5 px-3 py-2 mb-2">
                                                            {treeData.right_leg}
                                                        </Badge>
                                                        <p className="text-muted mb-0">Members</p>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col md={3}> {/* New column for total professionals */}
                                                <Card className="h-100 border-info">
                                                    <Card.Body className="text-center">
                                                        <div className="bg-info bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px' }}>
                                                            <FaUserTie className="text-info" size={24} />
                                                        </div>
                                                        <h5 className="mb-1">Professionals</h5>
                                                        <Badge pill bg="info" className="fs-5 px-3 py-2 mb-2">
                                                            {treeData.total_professional || 0}
                                                        </Badge>
                                                        <p className="text-muted mb-0">Total</p>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>

                                        <div className="d-md-none">
                                            <div className="tree-diagram" style={{ maxWidth: '100%', margin: '0 auto' }}>
                                                <div className="text-center mb-2">
                                                    <div style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#f8f9fa',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        border: '1px solid #dee2e6',
                                                        marginBottom: '5px'
                                                    }}>
                                                        <FaUser size={20} />
                                                    </div>
                                                    <h4 className="mb-1">{user_name}</h4>
                                                </div>

                                                <div style={{
                                                    position: 'relative',
                                                    height: '30px',
                                                    width: '100%',
                                                    marginBottom: '15px'
                                                }}>
                                                    <svg height="30" width="100%" style={{ position: 'absolute', top: 0, left: 0 }}>
                                                        <line
                                                            x1="50%" y1="0"
                                                            x2="12.5%" y2="30"
                                                            stroke="#adb5bd"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                        />
                                                        <line
                                                            x1="50%" y1="0"
                                                            x2="37.5%" y2="30"
                                                            stroke="#adb5bd"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                        />
                                                        <line
                                                            x1="50%" y1="0"
                                                            x2="62.5%" y2="30"
                                                            stroke="#adb5bd"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                        />
                                                        <line
                                                            x1="50%" y1="0"
                                                            x2="87.5%" y2="30"
                                                            stroke="#adb5bd"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                        />
                                                    </svg>
                                                </div>

                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    padding: '0 5px',
                                                    gap: '8px'
                                                }}>
                                                    {/* Blue Team */}
                                                    <div style={{ width: '23%' }}>
                                                        <div style={{
                                                            backgroundColor: 'white',
                                                            borderRadius: '8px',
                                                            border: '1px solid #4e73df',
                                                            padding: '8px 5px',
                                                            textAlign: 'center',
                                                            height: '100%',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>
                                                            <div style={{
                                                                width: '32px',
                                                                height: '32px',
                                                                borderRadius: '50%',
                                                                backgroundColor: 'rgba(78, 115, 223, 0.1)',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginBottom: '5px'
                                                            }}>
                                                                <FaCodeBranch size={14} color="#4e73df" />
                                                            </div>
                                                            <div style={{ fontSize: '0.7rem', fontWeight: '500', marginBottom: '3px' }}>Blue Team</div>
                                                            <Badge pill bg="primary" style={{
                                                                fontSize: '0.7rem',
                                                                padding: '3px 6px',
                                                                fontWeight: '500'
                                                            }}>
                                                                {treeData.left_leg}
                                                            </Badge>
                                                        </div>
                                                    </div>

                                                    {/* Yellow Team */}
                                                    <div style={{ width: '23%' }}>
                                                        <div style={{
                                                            backgroundColor: 'white',
                                                            borderRadius: '8px',
                                                            border: '1px solid #f6c23e',
                                                            padding: '8px 5px',
                                                            textAlign: 'center',
                                                            height: '100%',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>
                                                            <div style={{
                                                                width: '32px',
                                                                height: '32px',
                                                                borderRadius: '50%',
                                                                backgroundColor: 'rgba(246, 194, 62, 0.1)',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginBottom: '5px'
                                                            }}>
                                                                <FaCodeBranch size={14} color="#f6c23e" />
                                                            </div>
                                                            <div style={{ fontSize: '0.7rem', fontWeight: '500', marginBottom: '3px' }}>Yellow Team</div>
                                                            <Badge pill bg="warning" style={{
                                                                fontSize: '0.7rem',
                                                                padding: '3px 6px',
                                                                fontWeight: '500',
                                                                color: '#000'
                                                            }}>
                                                                {treeData.mid_leg}
                                                            </Badge>
                                                        </div>
                                                    </div>

                                                    {/* Green Team */}
                                                    <div style={{ width: '23%' }}>
                                                        <div style={{
                                                            backgroundColor: 'white',
                                                            borderRadius: '8px',
                                                            border: '1px solid #1cc88a',
                                                            padding: '8px 5px',
                                                            textAlign: 'center',
                                                            height: '100%',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>
                                                            <div style={{
                                                                width: '32px',
                                                                height: '32px',
                                                                borderRadius: '50%',
                                                                backgroundColor: 'rgba(28, 200, 138, 0.1)',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginBottom: '5px'
                                                            }}>
                                                                <FaCodeBranch size={14} color="#1cc88a" />
                                                            </div>
                                                            <div style={{ fontSize: '0.7rem', fontWeight: '500', marginBottom: '3px' }}>Green Team</div>
                                                            <Badge pill bg="success" style={{
                                                                fontSize: '0.7rem',
                                                                padding: '3px 6px',
                                                                fontWeight: '500'
                                                            }}>
                                                                {treeData.right_leg}
                                                            </Badge>
                                                        </div>
                                                    </div>

                                                    {/* Professionals */}
                                                    <div style={{ width: '23%' }}>
                                                        <div style={{
                                                            backgroundColor: 'white',
                                                            borderRadius: '8px',
                                                            border: '1px solid #36b9cc',
                                                            padding: '8px 5px',
                                                            textAlign: 'center',
                                                            height: '100%',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                        }}>
                                                            <div style={{
                                                                width: '32px',
                                                                height: '32px',
                                                                borderRadius: '50%',
                                                                backgroundColor: 'rgba(54, 185, 204, 0.1)',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginBottom: '5px'
                                                            }}>
                                                                <FaUserTie size={14} color="#36b9cc" />
                                                            </div>
                                                            <div style={{ fontSize: '0.7rem', fontWeight: '500', marginBottom: '3px' }}>Total</div>
                                                            <Badge pill bg="info" style={{
                                                                fontSize: '0.7rem',
                                                                padding: '3px 6px',
                                                                fontWeight: '500'
                                                            }}>
                                                                {treeData.total_professional || 0}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-5">
                                            <h4 className="mb-3">Professional Matches</h4>
                                            <Card>
                                                <Card.Body>
                                                    <div className="table-responsive">
                                                        <DataTable
                                                            columns={[
                                                                {
                                                                    name: 'SL No',
                                                                    selector: (row, index) => index + 1,
                                                                    sortable: false,
                                                                    width: '100px',
                                                                    cell: (row, index) => (
                                                                        <span>{(profPage - 1) * profRowsPerPage + index + 1}</span>
                                                                    )
                                                                },
                                                                {
                                                                    name: 'Profession',
                                                                    selector: row => row.name,
                                                                    sortable: true,
                                                                    cell: row => <span>{row.name}</span>
                                                                },
                                                                {
                                                                    name: 'Count',
                                                                    selector: row => row.count,
                                                                    sortable: true,
                                                                    cell: row => row.count
                                                                }
                                                            ]}
                                                            data={treeData.professional || []}
                                                            pagination
                                                            paginationPerPage={profRowsPerPage}
                                                            paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 60]}
                                                            onChangePage={(page) => setProfPage(page)}
                                                            onChangeRowsPerPage={(newPerPage) => {
                                                                setProfRowsPerPage(newPerPage);
                                                                setProfPage(1); // reset to page 1
                                                            }}
                                                            paginationComponentOptions={{
                                                                rowsPerPageText: 'Rows per page:',
                                                                rangeSeparatorText: 'of',
                                                                selectAllRowsItem: false,
                                                                selectAllRowsItemText: 'All'
                                                            }}
                                                            customStyles={{
                                                                rows: {
                                                                    style: {
                                                                        '&:nth-of-type(odd)': {
                                                                            backgroundColor: '#f9f9f9'
                                                                        },
                                                                        '&:hover': {
                                                                            backgroundColor: '#f1f1f1'
                                                                        }
                                                                    }
                                                                },
                                                                headRow: {
                                                                    style: {
                                                                        backgroundColor: '#f8f9fa',
                                                                        fontWeight: 'bold'
                                                                    }
                                                                }
                                                            }}
                                                            conditionalRowStyles={[
                                                                {
                                                                    when: row => row.color === 'green',
                                                                    style: {
                                                                        backgroundColor: '#d1e7dd'
                                                                    }
                                                                }
                                                            ]}
                                                            noDataComponent={
                                                                <div className="py-4 text-center">
                                                                    <FaUserTie size={32} className="text-muted mb-2" />
                                                                    <h5>No Professional Data Found</h5>
                                                                    <p className="text-muted">
                                                                        You don't have any professional matches yet
                                                                    </p>
                                                                </div>
                                                            }
                                                        />
                                                    </div>
                                                </Card.Body>
                                            </Card>

                                        </div>
                                    </>
                                )}
                            </Card.Body>
                        </Card>
                        <br />
                        <br />
                    </Tab.Pane>

                    <Tab.Pane eventKey="tabFour">
                        <Card className="mb-4">
                            <Card.Body>
                                {bankLoading ? (
                                    <div className="text-center py-5">
                                        <Spinner animation="border" variant="primary" />
                                        <p className="mt-2">Loading bank details...</p>
                                    </div>
                                ) : error ? (
                                    <Alert variant="danger" className="text-center">
                                        {error}
                                    </Alert>
                                ) : bankDetails ? (
                                    // Bank details exist - show details with edit button
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <h4 className="mb-0">Bank Account Details</h4>
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={handleEditBankDetails}
                                            >
                                                <FaEdit className="me-1" />
                                                Edit Details
                                            </Button>
                                        </div>

                                        <Row className="g-3">
                                            {/* Row 1 */}
                                            <Col md={6}>
                                                <div className="list-group list-group-flush">
                                                    <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                        <div>
                                                            <small className="text-muted d-block">Account Holder Name</small>
                                                            <span>{bankDetails.a_c_holder_name || 'Not provided'}</span>
                                                        </div>
                                                        <FaUser className="text-muted" />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="list-group list-group-flush">
                                                    <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                        <div>
                                                            <small className="text-muted d-block">Phone Number</small>
                                                            <span>{maskSensitiveData(bankDetails.phone_number) || 'Not provided'}</span>
                                                        </div>
                                                        <FaPhone className="text-muted" />
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Row 2 */}
                                            <Col md={6}>
                                                <div className="list-group list-group-flush">
                                                    <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                        <div>
                                                            <small className="text-muted d-block">Bank Name</small>
                                                            <span>{bankDetails.bank_name || 'Not provided'}</span>
                                                        </div>
                                                        <BsCardHeading className="text-muted" />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="list-group list-group-flush">
                                                    <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                        <div>
                                                            <small className="text-muted d-block">Branch</small>
                                                            <span>{bankDetails.branch || 'Not provided'}</span>
                                                        </div>
                                                        <FaCodeBranch className="text-muted" />
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Row 3 */}
                                            <Col md={6}>
                                                <div className="list-group list-group-flush">
                                                    <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                        <div>
                                                            <small className="text-muted d-block">Account Number</small>
                                                            <span>{maskSensitiveData(bankDetails.account_number) || 'Not provided'}</span>
                                                        </div>
                                                        <FaIdCard className="text-muted" />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="list-group list-group-flush">
                                                    <div className="list-group-item d-flex justify-content-between align-items-center py-3">
                                                        <div>
                                                            <small className="text-muted d-block">IFSC Code</small>
                                                            <span>{bankDetails.ifsc_code || 'Not provided'}</span>
                                                        </div>
                                                        <FaIdCard className="text-muted" />
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Row 4 */}
                                        </Row>


                                        <Row className="mt-4">
                                            <Col md={6}>
                                                <Card className="border">
                                                    <Card.Body>
                                                        <h5 className="mb-3">PAN Card Details</h5>
                                                        <div className="d-flex align-items-center">
                                                            <FaIdCard className="me-3 text-primary" size={24} />
                                                            <span>{bankDetails.pancard || 'Not provided'}</span>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={6}>
                                                <Card className="border">
                                                    <Card.Body>
                                                        <h5 className="mb-3">Aadhar Card Details</h5>
                                                        <div className="d-flex align-items-center">
                                                            <FaIdCard className="me-3 text-primary" size={24} />
                                                            <span>{bankDetails.aadharcard || 'Not provided'}</span>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </>
                                ) : (
                                    // No bank details found - show "Add Bank" button
                                    <div className="text-center py-5">
                                        <FaPiggyBank size={48} className="text-muted mb-3" />
                                        <h4>No Bank Account Found</h4>
                                        <p className="text-muted mb-3">
                                            You haven't added your bank account details yet.
                                        </p>
                                        <p className="text-muted mb-4">
                                            Add your bank details to receive benefits of payouts.
                                        </p>
                                        <Button
                                            variant="primary"
                                            onClick={handleAddBankDetails}
                                            className="px-4 py-2"
                                        >
                                            <FaPiggyBank className="me-2" />
                                            Add Bank Account
                                        </Button>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                        <br />
                        <br />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </Layout>
    );
};

export default UserProfilePage;